import styled from 'styled-components';

export const GenericFormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  gap: 16px;
`;
